module.exports = "/_next/static/images/7267dac0a1600db26a2288033e826ee0-comunidad-nu-lg.jpg";